module.exports = __webpack_public_path__ + "img/login_form_bg.f4d8e6f6.png";